<script lang="ts" setup>
import { Button } from '@collector/shared-ui'
import { BaseballIncidentId } from '@collector/sportsapi-client-legacy'
import { useBaseballParticipants } from '@desktop/views/Relation/Sports/Baseball/composables'
import {
  useEventIncidentsQueue,
  useIncidentName,
  usePitchIncidentsBlockades,
} from '@desktop/views/Relation/Sports/composables'

// composables
const eventIncidentsQueue = useEventIncidentsQueue()
const { getIncidentName } = useIncidentName()
const { battingParticipant } = useBaseballParticipants()
const { isEveryPitchIncidentBlocked } = usePitchIncidentsBlockades()

// methods
function onClick(): void {
  if (!battingParticipant.value) return

  eventIncidentsQueue.addIncident({
    incident_id: BaseballIncidentId.ResetStatsInBoxBallsStrikes,
  })

  eventIncidentsQueue.addIncident({
    participant_team_id: battingParticipant.value.id,
    incident_id: BaseballIncidentId.PlateAppearance,
  })
}
</script>

<template>
  <Button
    class="w-full"
    size="md"
    variant="default"
    :disabled="isEveryPitchIncidentBlocked"
    @click="onClick"
  >
    <span class="text-2xs font-bold capitalize">
      {{ getIncidentName(BaseballIncidentId.PlateAppearance) }}
    </span>
  </Button>
</template>
